"use client";

import React from "react";
import { ArrowRight, ShieldCheck, Lock, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToScreenWithConfidence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const trustSignals = [{
    text: "Operator-Led Execution",
    icon: ShieldCheck
  }, {
    text: "Strategic Advisory",
    icon: Lock
  }, {
    text: "Selective Studio",
    icon: CircleCheck
  }];
  return <section data-section-id="198535" id="begin-the-dialogue" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center p-4 bg-primary/20 rounded-full mb-8 backdrop-blur-sm transition-transform hover:scale-110 duration-500">
            <ShieldCheck className="size-8 text-primary" />
          </div>

          <h2 className="text-5xl md:text-6xl font-default font-medium tracking-tighter mb-6 text-foreground">
            Begin the Dialogue
          </h2>
          
          <p className="text-xl md:text-2xl font-default text-muted-foreground mb-10 leading-relaxed max-w-2xl mx-auto">
            1066 Ventures provides the strategic support and operator-level execution needed to validate and scale your vision. Join a selective community of founders building the future.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Button size="lg" className="w-full sm:w-auto text-base h-12 px-8 rounded-full bg-primary text-primary-foreground hover:scale-105 transition-all duration-300 shadow-xl shadow-primary/10" asChild>
              <Link to="#">
                Tell Us What You’re Building
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto text-base h-12 px-8 rounded-full border-primary/40 text-primary hover:bg-primary/10 transition-all duration-300" asChild>
              <Link to="#">
                Explore Branded Basecamp
              </Link>
            </Button>
          </div>

          <div className="pt-8 border-t border-border/10">
            <p className="text-xs text-muted-foreground mb-6 font-default font-medium uppercase tracking-widest opacity-70">
              The Obsidian Standard of Partnership
            </p>
            <div className="flex flex-wrap justify-center gap-x-8 gap-y-4">
              {trustSignals.map((signal, index) => {
              const Icon = signal.icon;
              return <div key={index} data-index={index} className="flex items-center gap-2 text-muted-foreground/80">
                    <Icon className="size-4 text-primary/80" />
                    <span className="text-sm font-default font-medium tracking-wide">{signal.text}</span>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}